import { Form } from "antd"
import BaseInputArea from "../../../../components/elements/BaseInputArea"
import BaseInputField from "../../../../components/elements/BaseInputField"
import BaseSection from "../../../../components/elements/BaseSection"
import { MajorOrderGet } from "../../../../data/Types"
import { returnAddressString } from "../../../../services/functions"
import { MajorOrderState } from "../../../../api/constants"
import { ReactComponent as EDIT } from "../../../../assets/EditICON.svg"
import { ReactComponent as CLOSE } from "../../../../assets/CloseICON.svg"
import { useEffect, useState } from "react"
import BaseSectionHeadline from "../../../../components/elements/BaseSectionHeadline"

type MajorOrderDetailInfoType = {
    majorOrder: MajorOrderGet
    updatedMajorOrder: MajorOrderGet
    setupdateMajorOrder: (e: any) => void
    updateMajorOrder: () => void
    archive: () => void
}

export default function MajorOrderDetailInfo(props: MajorOrderDetailInfoType) {
    const [form] = Form.useForm()
    const [editable, seteditable] = useState<boolean>(false)
    useEffect(() => {
        resetValues()
    }, [])
    const resetValues = () => {
        props.setupdateMajorOrder(undefined)
        form.setFieldsValue({
            amount: props.majorOrder.amount,
            description: props.majorOrder.description,
        })
    }
    return (
        <BaseSection classProps="gap-4 justify-between ">
            <Form
                className="h-full"
                form={form}
                onFinish={() => {
                    props.updateMajorOrder()
                    seteditable(false)
                }}>
                <div className="flex flex-col gap-4">
                    <BaseSectionHeadline
                        label="Informationen"
                        classProps="!mb-0"
                        icon={
                            editable ? (
                                <div className="flex gap-4 pb-1 items-center">
                                    <p title="Abbrechen">
                                        <CLOSE
                                            onClick={() => {
                                                seteditable(false)
                                                resetValues()
                                            }}
                                            className="w-6 h-6 cursor-pointer"
                                        />
                                    </p>
                                    <Form.Item className="m-0">
                                        <button disabled={!editable} type="submit" className="btn btn-primary btn-sm">
                                            Speichern
                                        </button>
                                    </Form.Item>
                                </div>
                            ) : (
                                <p title="Bearbeiten">
                                    <EDIT className="w-6 h-6 cursor-pointer" onClick={() => seteditable(!editable)} />
                                </p>
                            )
                        }
                    />
                    <BaseInputField
                        variant="filled"
                        label={"Kunde"}
                        type={"text"}
                        disabled
                        value={props.majorOrder.customer_id.customer.name}
                        onChange={() => {}}
                    />
                    <BaseInputField
                        variant="filled"
                        label={"Objekt"}
                        type={"text"}
                        disabled
                        value={props.majorOrder.object_id ? returnAddressString(props.majorOrder.object_id.adress) : "Kein Objekt ausgewählt"}
                        onChange={() => {}}
                    />
                    <Form.Item className="mb-2" name="amount" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                        <BaseInputField
                            disabled={!editable}
                            variant="filled"
                            label={"Betrag in  €"}
                            type={"number"}
                            value={props.majorOrder.amount}
                            onChange={(e) =>
                                props.setupdateMajorOrder((prev: MajorOrderGet) => ({
                                    ...prev,
                                    amount: Number(e),
                                }))
                            }
                        />
                    </Form.Item>
                    <Form.Item className="mb-2" name="description" rules={[{ required: true, message: "Muss einen Wert enthalten!" }]}>
                        <BaseInputArea
                            disabled={!editable}
                            variant="filled"
                            minRows={6}
                            maxRows={10}
                            label={"Beschreibung"}
                            value={props.majorOrder.description}
                            onChange={(e) =>
                                props.setupdateMajorOrder((prev: MajorOrderGet) => ({
                                    ...prev,
                                    description: e,
                                }))
                            }
                        />
                    </Form.Item>
                </div>
            </Form>
            <div className="flex w-full justify-end">
                <button disabled={props.majorOrder.state !== MajorOrderState.FULLY_BILLED} className="btn btn-outline btn-primary" onClick={props.archive}>
                    Archivieren
                </button>
            </div>
        </BaseSection>
    )
}
